import * as S from './styles';

export default function AccessPage() {
  return (
    <S.Container>
      <S.Title>You do not have access to this page</S.Title>
    </S.Container>
  );
}
